// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_1G-3_PRpWMZUITwR0tEKDd","dialog":"_3uuIMEIrAN7KS9KEWk_dAk","right":"_3Pjsr7SF84SKFLXzuqdge-","btn-assign":"qywwKu1BhxdLfwEAwjpk_"};